module.exports = __webpack_public_path__ + "img/unicom.a9f45092.jpg";